module.exports = "/images/cookie_policy.svg?a6a1e96cbfd309f05b03da996a690275";